module.exports = __webpack_public_path__ + "static/media/download-img.85780e6c.svg";